<template>
  <v-dialog v-model="getModalDescontoAdicionalVenda" persistent max-width="720px">
    <v-card outlined>
      <v-card-title>Aplicar desconto no total da venda</v-card-title>
      <v-form class="px-5">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 md12>
              <v-text-field
                v-model="getDescontoAdicionalTotalVenda"
                label="Desconto R$"
                v-mask="['#,##', '##,##', '###,###', '#.###,##', '##.###,##', '###.###,##']"
                outlined
                dense
                @click="$event.target.select()"
                @keyup.enter="aplicarDescontoAdicionalTotalVenda"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md12>
              <v-text-field v-model="getTotalVendaComDescontoAdicional" label="Total R$" v-mask="['#,##', '##,##', '###,###', '#.###,##', '##.###,##', '###.###,##']" outlined dense readonly @click="$event.target.select()"></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-form>
      <v-card-actions>
        <v-btn color="default" @click="setModalDescontoAdicionalVenda(false)" outlined>Voltar</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="aplicarDescontoAdicionalTotalVenda" outlined>Aplicar Desconto</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  // data() {
  //   return { descontoAdicionalTotalVenda: "0,00" };
  // },
  watch: {
    getDescontoAdicionalTotalVenda: function() {
      this.$store.commit("setTotalVendaComDescontoAdicional", this.$helper.formatReal(this.$helper.cleanFormatReal(this.getVenda.total) - this.$helper.cleanFormatReal(this.getDescontoAdicionalTotalVenda)));
    },
  },
  computed: {
    ...mapGetters(["getTotalVendaComDescontoAdicional", "getModalDescontoAdicionalVenda", "getVenda"]),
    getDescontoAdicionalTotalVenda: {
      set($value) {
        this.$store.commit("setDescontoAdicionalTotalVenda", $value);
      },
      get() {
        return this.$store.getters.getDescontoAdicionalTotalVenda;
      },
    },
  },
  methods: {
    ...mapActions(["setModalPermissaoFuncionario", "setModalDescontoAdicionalVenda"]),
    aplicarDescontoAdicionalTotalVenda() {
      if (this.$helper.cleanFormatReal(this.getDescontoAdicionalTotalVenda) <= 0) {
        this.$store.commit("snackbarWarning", "Informe o valor do desconto.");
        return;
      }

      if (this.$helper.cleanFormatReal(this.getDescontoAdicionalTotalVenda) > this.$helper.cleanFormatReal(this.getVenda.total)) {
        this.$store.commit("snackbarWarning", "O valor do desconto não pode ser maior que o total da venda.");
        return;
      }

      this.$store.commit("setPermissaoFuncionario", { ...this.$store.getters.getPermissaoFuncionario, permissao: "aplicar-desconto-adicional-total-venda", metodo: "aplicarDescontoAdicionalTotalVenda" });
      // this.$store.commit("setDescontoAdicionalTotalVenda", this.getDescontoAdicionalTotalVenda);
      this.setModalPermissaoFuncionario(true);
      // this.getDescontoAdicionalTotalVenda = "0,00";
    },
  },
};
</script>
